export default __webpack_public_path__ + "static/usz-df36ec9affcb1192985c6b4efd70d1d9.png";